import React, { useState } from 'react';
import { Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter, ListGroup, ListGroupItem, Tooltip } from 'reactstrap';

interface BadgeCellProps {
  row: any;
  column: any;
}
/**
 * PageSizeDropwdown
 *
 */
export const BadgeCell = (props: Readonly<BadgeCellProps>): JSX.Element => {
  const { row, column } = props;
  const [open, setOpen] = useState(false);
  const [ toggleTooltip, setToggleTooltip ] = useState(false);
  const compId = `r${row.index}-l${column.id}-toggle`;
  const badgeValue = row?.values[column?.id] ? row?.values[column?.id].length : 0;
  const badgeList = row?.values[column?.id] ? row.values[column.id] : [];
  return (
    <React.Fragment>
      { badgeValue === 1 &&
        <React.Fragment>
          {badgeList[0].name}
        </React.Fragment>
      }
      { badgeValue > 1 &&
        <React.Fragment>
          <Button id={compId} color="primary" data-toggle="tooltip" outline onClick={() => setOpen(true)}>
            <Badge color="primary">{badgeValue}</Badge>
          </Button>
          <Tooltip target={compId} isOpen={toggleTooltip} toggle={() => setToggleTooltip(!toggleTooltip)}>
            {badgeList.map(c => {
              return `${c.name}, `
            })}
          </Tooltip>
        </React.Fragment>
      }
      {badgeValue > 1 &&  
        <Modal isOpen={open} toggle={() => {setOpen(!open)}}>
          <ModalHeader>{column.Header}</ModalHeader>
          <ModalBody>
            <ListGroup>
              {badgeList.map(c => {
                return <ListGroupItem key={c.name}>{c.name}</ListGroupItem>
              })}
            </ListGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => setOpen(false)} >Close</Button>
          </ModalFooter>
        </Modal>
      }
    </React.Fragment>
  );
}
BadgeCell.displayName = 'BadgeCell';
